module.exports = __webpack_public_path__ + "media/images/emblems/Ersigen-coat_of_arms-4f06f91bbac94990195ccd02d5484e54.svg";